
export enum Statuses {
  Pending,
  Vectorized,
  Failed,
}
